var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialDiscord = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 4h13v10H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7289DA",
    d: "M8.246 8.55c-.513 0-.918.45-.918 1 0 .549.414.999.918.999.513 0 .918-.45.918-1 .01-.548-.405-.998-.918-.998m3.285 0c-.513 0-.918.45-.918 1 0 .549.414.999.918.999.513 0 .918-.45.918-1 0-.548-.405-.998-.918-.998"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7289DA",
    d: "M15.905 1H3.845A1.85 1.85 0 0 0 2 2.854v12.168a1.85 1.85 0 0 0 1.845 1.854h10.206l-.477-1.665 1.152 1.071 1.089 1.008L17.75 19V2.854A1.85 1.85 0 0 0 15.905 1m-3.474 11.754s-.324-.387-.594-.729c1.179-.333 1.629-1.071 1.629-1.071a5 5 0 0 1-1.035.531c-.45.189-.882.315-1.305.387a6.3 6.3 0 0 1-2.331-.009 7.6 7.6 0 0 1-1.323-.387 5 5 0 0 1-.657-.306c-.027-.018-.054-.027-.081-.045-.018-.009-.027-.018-.036-.027-.162-.09-.252-.153-.252-.153s.432.72 1.575 1.062c-.27.342-.603.747-.603.747-1.989-.063-2.745-1.368-2.745-1.368 0-2.898 1.296-5.247 1.296-5.247 1.296-.972 2.529-.945 2.529-.945l.09.108c-1.62.468-2.367 1.179-2.367 1.179s.198-.108.531-.261c.963-.423 1.728-.54 2.043-.567.054-.009.099-.018.153-.018a7.336 7.336 0 0 1 4.527.846s-.711-.675-2.241-1.143l.126-.144s1.233-.027 2.529.945c0 0 1.296 2.349 1.296 5.247 0 0-.765 1.305-2.754 1.368"
  })));
};
export { SvgSocialDiscord as ReactComponent };